export const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: 29/09/2025</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
        <p>
          This Privacy Policy explains how <strong>APF Reporting</strong> (“we,”
          “our,” “us”) collects, uses, and protects your information when you
          use our Service. By using the Service, you consent to the practices
          described here.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          2. Information We Collect
        </h2>
        <p>We may collect the following types of information:</p>
        <ul className="list-disc list-inside mt-2">
          <li>
            <strong>Account Information:</strong> Email, name, and
            authentication details (via Firebase Authentication).
          </li>
          <li>
            <strong>Usage Data:</strong> Information about how you use the
            Service, including interactions and preferences.
          </li>
          <li>
            <strong>Device Data:</strong> IP address, browser type, operating
            system, and related metadata.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          3. How We Use Your Information
        </h2>
        <p>Your information may be used to:</p>
        <ul className="list-disc list-inside mt-2">
          <li>Provide and improve the Service.</li>
          <li>
            Authenticate and manage user accounts via Firebase Authentication.
          </li>
          <li>Send important service-related notifications.</li>
          <li>Analyze usage trends to enhance user experience.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Third-Party Services</h2>
        <p>
          We use trusted third-party providers such as Firebase to operate our
          Service. These providers may collect and process your data in
          accordance with their own terms:
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>
            <a
              href="https://firebase.google.com/support/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              Firebase Privacy & Security
            </a>
          </li>
          <li>
            [Add links to other integrations, e.g., Stripe, Google Analytics,
            etc.]
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Data Retention</h2>
        <p>
          We retain your information for as long as necessary to provide the
          Service and comply with legal obligations. You may request deletion of
          your data at any time.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Data Security</h2>
        <p>
          We take reasonable steps to protect your data using Firebase’s
          security measures and industry-standard practices. However, no method
          of transmission or storage is completely secure.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Your Rights</h2>
        <p>Depending on your location, you may have rights such as:</p>
        <ul className="list-disc list-inside mt-2">
          <li>Accessing the information we hold about you.</li>
          <li>Requesting correction or deletion of your data.</li>
          <li>Withdrawing consent for data processing.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Children’s Privacy</h2>
        <p>
          Our Service is not directed at individuals under 13 (or the relevant
          age in your jurisdiction). We do not knowingly collect personal data
          from children.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          9. Changes to this Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time. Updates will be
          posted here with a revised “Last updated” date.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at
          <a
            href="mailto:support@yourapp.com"
            className="text-blue-600 underline ml-1"
          >
            hello@apfome.com
          </a>
          .
        </p>
      </section>
    </div>
  );
};
